// +----------------------------------------------------------------------
// | 领码（公众号导流）：暗号 → 自动发一张体验码
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 领码状态（进页面先问一次）
 *
 * @returns {Promise<{
 *   enabled:boolean,      // 总开关（false = 通道关闭）
 *   ready:boolean,        // 后端表结构就绪
 *   claimed:boolean,      // 我领过没
 *   code:string,          // 已领到的码（claimed=true 时有值）
 *   used:boolean,         // 领到的码是否已经核销掉了
 *   product_name:string,
 *   days:number,
 *   remaining:number,     // 池子剩余张数
 *   hint:string           // 页面提示语
 * }>}
 */
export function getClaimStatus() {
  return request.get('/redeem/status');
}

/**
 * 用暗号领码
 *
 * 幂等：同一个人重复提交只会拿到原来那张（first_time=false）。
 * 失败时 err.code：
 *   4100 暗号不对 / 通道未开启
 *
 * @param {string} keyword 暗号（大小写、全角半角、空格都容错）
 * @returns {Promise<{code:string,product_name:string,days:number,first_time:boolean,remaining:number}>}
 */
export function claimByKeyword(keyword) {
  return request.post('/redeem/claim', { keyword });
}
